import { useEffect } from 'react';

const LINKEDIN_PARTNER_ID = '9635996';
const LINKEDIN_INSIGHT_SRC = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';

/**
 * Central place for third-party marketing / advertising tags (LinkedIn, etc.).
 * Mount once near the app root so tags load on every page.
 *
 * Note: LinkedIn's <noscript> pixel lives in public/index.html — React cannot
 * render a useful noscript fallback when JavaScript is disabled.
 */
function MarketingTags() {
    useEffect(() => {
        window._linkedin_partner_id = LINKEDIN_PARTNER_ID;
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        if (!window._linkedin_data_partner_ids.includes(LINKEDIN_PARTNER_ID)) {
            window._linkedin_data_partner_ids.push(LINKEDIN_PARTNER_ID);
        }

        if (!window.lintrk) {
            window.lintrk = function (a, b) {
                window.lintrk.q.push([a, b]);
            };
            window.lintrk.q = [];
        }

        if (!document.querySelector(`script[src="${LINKEDIN_INSIGHT_SRC}"]`)) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = LINKEDIN_INSIGHT_SRC;
            const firstScript = document.getElementsByTagName('script')[0];
            firstScript.parentNode.insertBefore(script, firstScript);
        }
    }, []);

    return null;
}

export default MarketingTags;
